<!DOCTYPE html>
@if (getLeaderPlayerWeek$ | async; as month) {
  @if (getHallOfFame$ | async; as fame) {
    @if (leaderPlayerMonth$ | async; as teams) {
      <div class="Leadbords">
        <ion-card class="Leadbords-tab">
          <!-- Card Heading -->
          <ion-card-header class="top-header">
            <span class="card-title">{{ "leaderboard.Leaderboard" | translate }}</span>
            <ion-card-subtitle class="sub-title">
              {{ "leaderboard.top_info" | translate }}
            </ion-card-subtitle>
          </ion-card-header>
          <ion-card-content class="contibute-tab">
            <!-- Inner currentTabs -->
            <div class="Leadbords-sub-tab">
              <div class="currentTabs-wrapper">
                <mat-tab-group #matTabGroup class="leader-mat-tab" (selectedTabChange)="tabChanged($event)"
                  [selectedIndex]="currentSection">
                  <!-- Tab-1 -->
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span
                      [ngClass]="selectedLanguage === 'en' ? 'tab-label' : 'tab-label-lng'">{{month?.content?.[selectedLanguage]?.title}}</span>
                    </ng-template>
                    <!-- This is For Empty condition -->
                    @if (month.current_list.length === 0) {
                      <div class="leader-player">
                        <div class="top-heading">
                          <span class="title">{{ "leaderboard.Top_players" | translate }}</span>
                          <br />
                          <span class="sub-title">{{ "leaderboard.position" | translate }} {{ getRank(month?.current_list)
                          }}</span>
                        </div>
                        <div class="no-leadbords">
                          <div class="img-blank">
                            <img src="../../../../assets/icon/img-icon.svg" alt="" />
                            <span class="link">{{ "leaderboard.we_Teams" | translate }} <br />
                              <a href=""> {{ "leaderboard.be_Frist" | translate }}</a></span>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- This is For  Data available Condition -->
                      @if (month.current_list.length > 0) {
                        <div class="leader-player">
                          <div class="top-heading">
                            <span class="title">{{ "leaderboard.Top_players" | translate }}</span>
                            <br />
                            <span class="sub-title">{{ "leaderboard.position" | translate }} {{ getRank(month?.current_list)
                            }}</span>
                          </div>
                          <!-- List wrapper-->
                          @if (month && month.current_list) {
                            <div class="tab-wrapper">
                              @for (listOne of month?.current_list; track listOne; let i = $index) {
                                <ion-row class="contribute-list border-bottom"
                                  [ngClass]="i === 2 || i === 9 ? 'list-margin' : 'contribute-list'">
                                  <ion-col size="1" class="list-count">
                                    <p class="index-value">{{ i + 1 }}</p>
                                  </ion-col>
                                  <ion-col size="9" class="contributer">
                                    <div class="game-profile">
                                      <img src="{{ listOne?.profile_picture }}" alt="contribute.png" />
                                    </div>
                                    <div class="contribute-game">
                                      <span>{{ listOne?.profile_nickname }}</span>
                                      <div class="game-value">
                                        <img src="../../../../assets/icon/yellow.png" alt="" />
                                        <span>{{ listOne?.gxp }}</span>
                                      </div>
                                    </div>
                                  </ion-col>
                                  <ion-col size="2" class="progress-arrow">
                                    <img src="{{getWeekCount(listOne)}}" alt="" />
                                  </ion-col>
                                  @if (i === 2) {
                                    <ion-col size="12"></ion-col>
                                  }
                                </ion-row>
                              }
                            </div>
                          }
                        </div>
                      }
                    </mat-tab>
                    <!-- Tab-2 -->
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <span class="tab-label">{{teams?.content?.[selectedLanguage]?.title}}</span>
                      </ng-template>
                      <!-- This is for Empty state  -->
                      @if (teams?.current_list.length === 0) {
                        <div class="leader-player">
                          <div class="top-heading">
                            <span class="title">{{ "leaderboard.Top_players" | translate }}</span>
                            <br />
                            <span class="sub-title">{{ "leaderboard.position" | translate }} {{ getRank(teams?.current_list)
                            }}</span>
                          </div>
                          <!-- No Leadbord data -->
                          <div class="no-leadbords">
                            <div class="img-blank">
                              <img src="../../../../assets/icon/img-icon.svg" alt="" />
                              <span class="link">{{ "leaderboard.we_Teams" | translate }} <br />
                                <a href=""> {{ "leaderboard.be_Frist" | translate }}</a></span>
                              </div>
                            </div>
                          </div>
                        }
                        <!--This is for data is Available  -->
                        @if (teams?.current_list.length > 0) {
                          <div class="leader-player">
                            <div class="top-heading">
                              <span class="title">{{ "leaderboard.Top_players" | translate }}</span>
                              <br />
                              <span class="sub-title">{{ "leaderboard.position" | translate }} {{ getRank(teams?.current_list)
                              }}</span>
                            </div>
                            <div class="tab-wrapper">
                              @for (listOne of teams?.current_list; track listOne; let i = $index) {
                                <ion-row class="contribute-list border-bottom"
                                  [ngClass]="i === 2 || i === 9 ? 'list-margin ' : 'contribute-list'">
                                  <ion-col size="1" class="list-count">
                                    <p class="index-value">{{ i + 1 }}</p>
                                  </ion-col>
                                  <ion-col size="9" class="contributer">
                                    <div class="game-profile">
                                      <img src="{{ listOne?.profile_picture }}" alt="contribute.png" />
                                    </div>
                                    <div class="contribute-game">
                                      <span>{{ listOne?.profile_nickname }}</span>
                                      <div class="game-value">
                                        <img src="../../../../assets/icon/yellow.png" alt="" />
                                        <span>{{ listOne?.gxp }}</span>
                                      </div>
                                    </div>
                                  </ion-col>
                                  <ion-col size="2" class="progress-arrow">
                                    <img src="{{getMonthCount(listOne)}}" alt="" />
                                  </ion-col>
                                  @if (i === 2) {
                                    <ion-col size="12"></ion-col>
                                  }
                                </ion-row>
                              }
                            </div>
                          </div>
                        }
                      </mat-tab>
                      <!--Tab-3 -->
                      <mat-tab>
                        <ng-template mat-tab-label>
                          <span class="tab-label">{{fame?.content?.[selectedLanguage]?.title}}</span>
                        </ng-template>
                        <!-- No Leadbords Heading and sub heading of sub tabs-1 -->
                        @if (fame?.current_list.length === 0) {
                          <div class="leader-player">
                            <div class="top-heading">
                              <span class="title">{{ "leaderboard.Top_Teams" | translate }}</span>
                              <br />
                              @if (getRank(fame?.current_list) != 'No current ranking') {
                                <span class="sub-title">{{
                                "leaderboard.position" | translate }} {{ getRank(fame?.current_list) | async }}</span>
                              }
                              @if (getRank(fame?.current_list) == 'No current ranking') {
                                <span class="sub-title">{{
                                "leaderboard.position" | translate }} {{ getRank(fame?.current_list) | async }}</span>
                              }
                            </div>
                            <!-- No Leadbord data -->
                            <div class="no-leadbords">
                              <div class="img-blank">
                                <img src="../../../../assets/icon/img-icon.svg" alt="" />
                                <span class="link">{{ "leaderboard.we_Teams" | translate }} <br />
                                  <a href="">{{ "leaderboard.be_Frist" | translate }}</a></span>
                                </div>
                              </div>
                            </div>
                          }
                          <!-- Heading and subheading of sub tabs-3 -->
                          @if (fame?.current_list.length > 0) {
                            <div class="leader-player">
                              <div class="top-heading">
                                <span class="title">{{ "leaderboard.Top_Teams" | translate }}</span>
                                <br />
                                <span class="sub-title">{{ "leaderboard.position" | translate }} {{ getRank(fame?.current_list)
                                }}</span>
                              </div>
                              <!--  List of Tab-3 -->
                              <div class="tab-wrapper">
                                @for (listOne of fame.current_list; track listOne; let i = $index) {
                                  <ion-row class="contribute-list border-bottom"
                                    [ngClass]="i === 2 || i === 9 ? 'list-margin' : 'contribute-list'">
                                    <ion-col size="1" class="list-count">
                                      <p class="index-value">{{ i + 1 }}</p>
                                    </ion-col>
                                    <ion-col size="9" class="contributer">
                                      <div class="game-profile">
                                        <img src="{{ listOne?.profile_picture }}" alt="contribute.png" />
                                      </div>
                                      <div class="contribute-game">
                                        <span>{{ listOne?.profile_nickname }}</span>
                                        <div class="game-value">
                                          <img src="../../../../assets/icon/yellow.png" alt="" />
                                          <span>{{ listOne?.gxp }}</span>
                                        </div>
                                      </div>
                                    </ion-col>
                                    <ion-col size="2" class="progress-arrow">
                            <img src="
                                {{getDateDifference(listOne) }}
                              " alt="" />
                                      </ion-col>
                                      @if (i === 2) {
                                        <ion-col size="12"></ion-col>
                                      }
                                    </ion-row>
                                  }
                                </div>
                              </div>
                            }
                          </mat-tab>
                        </mat-tab-group>
                      </div>
                    </div>
                    <!-- end -->
                  </ion-card-content>
                </ion-card>
              </div>
            } @else {
              <app-in-progress-animation type="missions-cards-skeleton"></app-in-progress-animation>
            }
          } @else {
            <app-in-progress-animation type="missions-cards-skeleton"></app-in-progress-animation>
          }
        } @else {
          <app-in-progress-animation type="missions-cards-skeleton"></app-in-progress-animation>
        }

